import { AgendamentoPraticoServices } from './apis/agendamento-pratico/_agendamento-pratico';
import { AgendamentoServices } from './apis/agendamento/_agendamento';
import { AuditoriaServices } from './apis/auditoria/_auditoria';
import { DocumentoServices } from './apis/documento/_documento';
import { FinanceiroServices } from './apis/financeiro/_financeiro';
import { GestaoServices } from './apis/gestao/_gestao';
import { ItendidateServices } from './apis/identidade/_identidade';
import { LogServices } from './apis/log/_log';
import { MarcacaoServices } from './apis/marcacao/_marcacao';
import { LocationService } from './outros/location.service';
import { TokenService } from './outros/token.service';

export const Services = [
  AgendamentoPraticoServices,
  AgendamentoServices,
  AuditoriaServices,
  DocumentoServices,
  FinanceiroServices,
  GestaoServices,
  ItendidateServices,
  MarcacaoServices,
  TokenService,
  LogServices,
  LocationService
]
